import store from '@/store';
import router from '@/router';

export default function translate(key) {
  const messages = store.getters.bootstrap?.messages || {};
  const publicViewMessages = store.getters.getPublicTranslations;
  const isUnprotected = router.currentRoute.meta?.unprotected;

  return isUnprotected ? publicViewMessages[key] || messages[key] || key : messages[key] || key;
}
